(function () {

    'use strict';

    angular
        .module('app.layout')
        .controller('FooterController', [
            'API_CONFIG',
            'APP_CONFIG',
            '$scope',
            '$routeParams',
            'ApiService',
            'CommonUtil',
            FooterController
        ]);

    function FooterController(API_CONFIG, APP_CONFIG, $scope, $routeParams, apiService, commonUtil) {
        var vm = this;

        init();

        function init() {
            $scope.$on('layoutInitSuccess', function () {
                if (angular.isDefined($routeParams.locCode) && angular.isDefined($routeParams.langCode)) {
                    apiService.getLocations($routeParams.langCode).then(function (response) {
                        var location = apiService.getLocationByCode(response.data, $routeParams.locCode);
                        if (angular.isDefined(location) && location.locationCode !== APP_CONFIG.DEFAULT_HOME) {
                            if (angular.isArray(location.contacts)) {
                                vm.auctionContact = commonUtil.findById(location.contacts, 'contactType', 'customersupport');
                            }
                            vm.googleMapUrl = "https://www.google.com/maps/embed/v1/place?q="
                                + location.locationName.replace(/ /gi, '+')
                                + "&key=" + API_CONFIG.google.GOOGLE_MAP_EMBED_API_KEY;
                        }
                    });
                }
            });
        }
    }

})();


// WEBPACK FOOTER //
// ./app/layout/footer/FooterController.js